var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("article", [
    _c("div", { staticClass: "box-white -type3" }, [
      _c("div", { staticClass: "header" }, [
        _c("div", { staticClass: "col" }, [
          _vm._v(
            " " + _vm._s(/*Total Account*/ _vm.$t("MINQ-01-01-02-12")) + " : "
          ),
          _c("em", [_vm._v(_vm._s(_vm.summary.brifAcnCnt))])
        ]),
        _c("div", { staticClass: "col text" }, [
          _vm._v(_vm._s(/*합계*/ _vm.$t("MINQ-01-01-01-05")))
        ])
      ]),
      _c("div", { staticClass: "content" }, [
        _c(
          "div",
          { staticClass: "account-info -type2" },
          _vm._l(_vm.summary.info, function(item, i) {
            return _c("div", { key: i, staticClass: "item amount" }, [
              _c("span", { staticClass: "exchange-unit" }, [
                _vm._v(" " + _vm._s(item.brifCncycd) + " "),
                _c("em", [_vm._v(_vm._s("(" + item.brifAcnCnt + ")"))])
              ]),
              _c("span", {
                staticClass: "total",
                domProps: {
                  innerHTML: _vm._s(_vm.$num(item.brifTotalBal, null, true))
                }
              })
            ])
          }),
          0
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }